import { useRouter } from "next/router";
import Layout from "../../components/layout";
import style from "./contact.module.scss";
import getContactLocales from "../../locales/locales_contact";
import OpenGraphTwitterCard from "../../components/seo/OpenGraphTwitterCard";
import MainBlob from "../../components/animate/MainBlob";

export default function ContactUs() {
	const router = useRouter();

	const { locale, pathname } = router;

	const dictionary = getContactLocales(locale);

	const itemList = [
		{
			id: "c1",
			title: "Sales",
			text: "If you would like to purchase Enterprise package , we will be happy to advise you on the configuration most suited to your needs and on most favorable conditions.",
			mail: "support@bgrem.ai",
		},
		{
			id: "c2",
			title: "Support",
			text: "Our support service will answer any of your questions related to working with BgRem. You can contact us with technical issues, as well as sales questions.",
			mail: "support@bgrem.ai",
		},
		{
			id: "c3",
			title: "Media",
			text: "Our company is open to communication with the press and the community on a wide range topics related to ML Technology.",
			mail: "support@bgrem.ai",
		},
	];

	const getCanonicalLink = (locale) => {
		const enList = ["en", "ja", "ar"];

		if (enList.includes(locale)) {
			return `https://bgrem.ai/contact-us/`;
		} else {
			return `https://bgrem.ai/${locale}/contact-us/`;
		}
	};

	return (
		<Layout>
			<OpenGraphTwitterCard title={dictionary["title"]} description={dictionary["description"]} url={pathname} canonical={getCanonicalLink(locale)} />
			<section className={style.section}>
				<div className={style.description}>
					<h1 className={style.title} dangerouslySetInnerHTML={{ __html: `${dictionary["page title"]}` }} />
					<p className={style.subtitle}>
						We are always happy to answer any questions related to BgRem from our current and potential customers, colleagues from the professional community, journalists and anyone who is interested
						in our service.
					</p>
				</div>
				<div className={style.container}>
					{itemList.map((item) => (
						<div className={style.item} key={item.id}>
							<h2 className={style["item-title"]}>{item.title}</h2>
							<p className={style["item-text"]}>{item.text}</p>
							<a className={style.link} href={`mailto:${item.mail}`}>
								{item.mail}
							</a>
						</div>
					))}
				</div>
				<p className={`${style.subtitle} ${style.more}`}>With all other questions please contact us at:</p>
				<a className={`${style.link} ${style.more}`} href="mailto:support@bgrem.ai">
					support@bgrem.ai
				</a>
				<MainBlob isBack={true} />
			</section>
		</Layout>
	);
}
